module.exports = __webpack_public_path__ + "static/media/paper_featured.8211410a.jpg";